import {useRef, useEffect} from 'react';
import {select, scaleBand, axisBottom, 
    scaleLinear, axisLeft, max} from 'd3';

import useResizeObserver from '../../Utils/resizeObserver';
import {tooltip, formatValue} from './Component';
import './Charts.css';

const Barchart = ({data, wrapperRef, dataKey, label, fill}) => {
    const svgRef=useRef()
    const dimensions=useResizeObserver(wrapperRef)

    useEffect(()=>{
        if (!data || !dimensions) return;            
        const svg=select(svgRef.current)
        const marginTop = 20;
        const marginRight = 0;
        const marginBottom = 30;
        const marginLeft = 50;

        // Define scales
        const x = scaleBand()
        .domain(data.map(d => d[label]))
        .range([marginLeft, dimensions.width - marginRight])
        .padding(0.2);

        const y = scaleLinear()
        .domain([0, max(data, d => d[dataKey])]).nice()
        .range([dimensions.height - marginBottom, marginTop]);

        // Define axes
        const xAxis = axisBottom(x).tickSizeOuter(0);

        // const yAxis = axisLeft(y).tickFormat(y => (y * 100).toFixed());
        const yAxis = axisLeft(y).tickFormat(formatValue);

        // Add X-axis
        svg.select(".x-axis")
        .attr("transform", `translate(0,${dimensions.height - marginBottom})`)
        .call(xAxis);

        // Add Y-axis
        svg.select(".y-axis")
        .attr("transform", `translate(${marginLeft},0)`)
        .call(yAxis)
        .call(g => g.select(".domain").remove());

        svg.selectAll(".bar")
        .data(data)
        .join('rect')
        .attr("class", "bar")
        .attr("x", d => x(d[label]))
        .attr("y", dimensions.height - marginBottom)
        .attr("width", x.bandwidth())
        .attr("height", 0)
        .attr("fill", "#6FCE96")
        .on('mouseover', (event, d) => {
            tooltip.transition().style('opacity', 1);
            tooltip
            .html(`${label}: ${d[label]}<br/>${dataKey}: ${d[dataKey]}`)
            .style('left', `${event.pageX}px`)
            .style('top', `${event.pageY - 28}px`);
        })
        .on('mouseout', () => {
            tooltip.transition().duration(500).style('opacity', 0);
        })
        .transition()
        .duration(500) 
        .attr("fill", fill)
        .attr("y", d => y(d[dataKey]))
        .attr("height", d => dimensions.height - marginBottom - y(d[dataKey]));
    }, [data, dimensions, dataKey, label, fill])

  return (
    <div className='chart_wrapper_container'>
        <svg ref={svgRef}>
            <g className='x-axis'/>
            <g className='y-axis'/>
            <g className='y-right-axis'/>
        </svg>
    </div>
  )
}

export default Barchart